import { type ClassValue } from "clsx"
import { cn } from "~/common/shadcn-utils"

export const IntegrationCard = ({
  logo,
  title,
  description,
  badge,
  footer,
  className,
}: {
  logo: React.ReactNode
  title: string
  description: string
  badge?: React.ReactNode
  footer?: React.ReactNode
  className?: ClassValue
}) => {
  return (
    <div
      className={cn(
        "flex flex-col rounded-lg border border-gray30 p-6 min-h-[240px]",
        className
      )}
    >
      <div className="flex gap-4">
        <div className="w-16 h-16 shrink-0 overflow-hidden rounded-xl">
          {logo}
        </div>
        <div className="flex flex-col">
          <div className="flex items-center gap-2">
            <p className="font-bold">{title}</p>
            {badge}
          </div>
          <p className="text-sm text-gray50 mt-1">{description}</p>
        </div>
      </div>
      {footer && (
        <div className="mt-auto pt-6 flex items-center justify-between gap-2">
          {footer}
        </div>
      )}
    </div>
  )
}
